/* ASSET ITEM COMPONENT *******************************************************/

/* react redux */
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* Tools */
import _ from 'lodash'

/* Utilities */
import { filterAndSort } from 'util/list'

/* Components */
import AssetItem from './item'
import UploadItem from './upload'

/* Widgets */
import SearchInput from 'widget/search-input'
import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'
import SortToolbar from 'widget/sort-toolbar'

/* Actions */
import { showModal, hideModal } from 'react-redux/actions/modal'
import {
  fetchItems,
  saveFilter,
  fetchFilter,
  uploadFile,
  fetchSort,
  saveSort,
  nextPage
} from 'react-redux/actions/asset'

/* Selectors */

import selector from './selector'

/* Styles */
import "./list.css"

class AssetList extends Component {

  constructor(props) {
    super(props)
    this.state = { showBackToTop: false }
  }

  componentDidMount() {
    const { fetchFilter, fetchSort, filter, sort } = this.props
    if (!filter.initialized) fetchFilter()
    if (!sort.initialized) fetchSort()
    window.addEventListener("resize", this.loadMore.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.loadMore.bind(this));
  }

  componentWillReceiveProps(nextProps) { }

  componentDidUpdate() {
    const {
      fetchItems,
      pagination,
      maxResults,
      fetchingList,
      filter,
      globalFilter,
      query,
      sort
    } = this.props
    const initialized = filter.initialized
      && globalFilter.initialized
      && sort.initialized
    const filterString = _.compact(
      [filter.expression, globalFilter.expression]
    ).join(" ")
    const resultChange = filterString !== query.filter
      || sort.field !== query.sort_by_field
      || sort.reverse[sort.field] != query.reverse_order
    const shouldLoad = resultChange || pagination.page !== query.page

    if (initialized && !fetchingList) {
      if (shouldLoad) {
        fetchItems(
          {
            filter: filterString,
            page: resultChange ? 0: pagination.page
          }
        )
      } else {
        this.loadMore()
      }
    }
  }

  filterAssets(value) {
    const { saveFilter } = this.props
    saveFilter(value)
  }

  resetFilter(e) {
    const { saveFilter } = this.props
    saveFilter("")
  }

  loadMore() {
    const { pagination, nextPage } = this.props
    if (
      !pagination.reachedEnd
      && (
        this.listBody
        && this.listElem
        && (this.listBody.clientHeight + 200) >= this.listElem.scrollHeight - this.listBody.scrollTop
      )
    ) {
      nextPage()
    }
  }

  onScroll(e) {
    if (!this.state.showBackToTop && this.listBody.scrollTop > 0)
      this.setState({ showBackToTop: true })
    else if (this.state.showBackToTop && this.listBody.scrollTop == 0)
      this.setState({ showBackToTop: false })
    this.loadMore()
  }

  onBackToTopClick(e) {
    this.listBody.scrollTop = 0
  }

  /**
  * Show a Placeholder if no assets are available
  */
  renderPlaceholder() {
    const { filter, list, t } = this.props
    if(list.length) return null
    let text
    if (filter.expression === "") text = t("asset:list.empty.noItems")
    else text = t("asset:list.empty.noResults")
    return <li key="placeholder" className="placeholder">{ text }</li>
  }


  /**
  * Show a Placeholder if no assets are available
  */
  renderUploadSectionHeadline() {
    const { t } = this.props
    return (
      <div
        key="upload-section-headline"
        className="section-headline"
      >
        <span className="wrapper">{ t('asset:list.upload.sectionHeadline') }</span>
      </div>
    )
  }

  /**
  * Render Asset Items as list elements
  */
  renderUploadItems() {
    const { uploadList } = this.props
    return (
      _.map(uploadList, (item) => {
        return <UploadItem tid={ item } key={ item }/>
      })
    )
  }

  renderUploadSection() {
    const { uploadList } = this.props
    if (uploadList.length) {
      return (
        <li>
          { this.renderUploadSectionHeadline() }
          <ul className="upload-section">
            { this.renderUploadItems() }
          </ul>
        </li>
      )
    }
    return null
  }
  /**
  * Render Asset Items as list elements
  */
  renderItems() {
    const { list } = this.props
    return (
      _.map(list, (item) => {
        return <AssetItem uid={ item } key={ item }/>
      })
    )
  }


  uploadFiles(e) {
    const { uploadFile } = this.props
    _.each(e.target.files, (file, index) => {
      uploadFile(file)
    })
    e.target.value = "";
  }

  renderUploadButton() {
    const { t, filter } = this.props
    return (
      <span className="upload">
        <input
          title={ t("asset:list.upload.buttonTitle") }
          type="file" id="file-upload-input"
          onChange={ this.uploadFiles.bind(this) }
          multiple="true"
          accept="video/*,image/*,.v4l2,.http,.url"
        />
        <label htmlFor="file-upload-input" title={ t("asset:list.upload.buttonTitle") }>
          <Icon
            icon={ ICON.UPLOAD }
            size={ 24 }
            circle={ true }
            interactive={ true }
          />
        </label>
      </span>
    )
  }

  onSortSelect(field, reverse) {
    const { sort, saveSort } = this.props
    let r = Object.assign({}, sort.reverse)
    r[field] = reverse
    saveSort({ field, reverse: r })
  }

  renderSortToolbar() {
    const {
      sort,
      t
    } = this.props
    const items = [
      {
        label: t("asset:list.sort.name"),
        name: "name",
        reverse: sort.reverse.name,
        selected: sort.field === "name"
      },
      {
        label: t("asset:list.sort.fileName"),
        name: "fileName",
        reverse: sort.reverse.fileName,
        selected: sort.field === "fileName"
      },
      {
        label: t("asset:list.sort.timeCreated"),
        name: "timeCreated",
        reverse: sort.reverse.timeCreated,
        selected: sort.field === "timeCreated"
      },
      {
        label: t("asset:list.sort.timeModified"),
        name: "timeModified",
        reverse: sort.reverse.timeModified,
        selected: sort.field === "timeModified"
      },
    ]
    return (
      <SortToolbar
        items={ items }
        onSelect={ this.onSortSelect.bind(this) }
      ></SortToolbar>
    )
  }

  renderBackToTop() {
    if(this.state.showBackToTop) return (
      <div className="back-to-top">
        <Icon
          icon={ ICON.SCROLL_TO_TOP }
          scheme={ ICON_SCHEME.ACTION }
          size={ 32 }
          circle={ true }
          interactive={ true }
          onClick={ this.onBackToTopClick.bind(this) }
        />
      </div>
    )
    return null
  }

  renderNextPage() {
    const { pagination, nextPage, t } = this.props
    if (!pagination.reachedEnd) {
      return (
        <li
          key="pagination-helper"
          className="pagination-helper"
          onClick={ nextPage.bind(this) }
        >
          <div className="spinner">
            <Icon
              icon={ ICON.LOADING_SYNC }
              scheme={ ICON_SCHEME.ACTION }
              size={ 32 } circle={ true }
              interactive={ true }
              spin={ true }
              interactive={ true }
            />
          </div>
          <div className="caption">
            { t("asset:list.pagination.loading") }
          </div>
        </li>
      )
    }
    return null
  }

  render() {
    const { t, filter } = this.props
    return (
      <div className="asset-list component column-list">
        <div className="header">
          <h2>{ t("asset:list.headline") }</h2>
          { this.renderUploadButton() }
        </div>
        <div className="filter-input-wrapper">
          <SearchInput
            className="filter-input"
            type="text"
            onChange={ this.filterAssets.bind(this) }
            onReset={ this.resetFilter.bind(this) }
            value={ filter.expression || "" }
            placeholder={t("asset:list.searchInput.placeholder")}
          />
        </div>
        { this.renderSortToolbar() }
        <div
          className="body"
          ref={ (ref) => { this.listBody = ref } }
          onScroll={ this.onScroll.bind(this) }
        >

          <ul
            className="list"
            ref={ (ref) => { this.listElem = ref } }
          >
            { this.renderUploadSection() }
            { this.renderPlaceholder() }
            { this.renderItems() }
            { this.renderNextPage() }
          </ul>
        </div>
        { this.renderBackToTop() }
      </div>
    )
  }
}

AssetList.propTypes = {}

const mapStateToProps = (state, props) => selector(state)


function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveSort,
      fetchSort,
      saveFilter,
      fetchFilter,
      fetchItems,
      nextPage,
      showModal,
      uploadFile
    },
    dispatch
  )
}

const reduxComponent = connect(mapStateToProps, mapDispatchToProps)(AssetList)
const translatedComponent = translate([], { withRef: true })(reduxComponent)
export default translatedComponent



// WEBPACK FOOTER //
// ./src/app/component/asset/list.jsx